import { STORAGE_CONST, TRACKING_EVENTS } from '@common/constants'
import { usePageLoad } from '@common/hooks'
import { BUY_TRACKING_COMPONENTS } from '@buy/constants'
import { trackEvent } from '@common/utils'
import { useBuyTracking } from './useBuyTracking'

export interface ConfirmationPageTrackingParams {
    isLabelsLoaded: boolean
    invoiceID: string
}

export const useConfirmationPageTracking = ({ isLabelsLoaded, invoiceID }: ConfirmationPageTrackingParams) => {
    const { track } = useBuyTracking()
    const componentName = BUY_TRACKING_COMPONENTS.CONFIRMATION_PAGE

    // VIEW_CONTENT event
    usePageLoad(() => {
        track({ event: TRACKING_EVENTS.VIEW_CONTENT }, componentName)
    }, isLabelsLoaded)

    // COMPLETE_BUY_FLOW event
    usePageLoad(() => {
        const sessionStorageKeyName = `${STORAGE_CONST.STORED_GA_EVENT_PREFIX}${TRACKING_EVENTS.COMPLETE_BUY_FLOW}`

        // Retreive the event data that was put in sessionStorage before redirecting to OnePay
        // (See where it gets set at src/products/buy/saga/checkout-form/form-submission.ts)
        const value = window.sessionStorage.getItem(sessionStorageKeyName)
        if (value) {
            const event = JSON.parse(value)

            // Log the event to google analytics
            trackEvent(event)

            // Remove from sessionStorage now that we have logged it to google analytics
            window.sessionStorage.removeItem(sessionStorageKeyName)
        }
    }, isLabelsLoaded)

    // PURCHASE event
    usePageLoad(() => {
        const sessionStorageKeyName = `${STORAGE_CONST.STORED_GA_EVENT_PREFIX}${TRACKING_EVENTS.PURCHASE}`

        // Retreive the event data that was put in sessionStorage before redirecting to OnePay
        // (See where it gets set at src/products/buy/saga/checkout-form/form-submission.ts)
        const value = window.sessionStorage.getItem(sessionStorageKeyName)
        if (value) {
            const event = JSON.parse(value)

            // Update the event to contain the invoiceID now that we have it
            event.eventData.actionField.transaction_id = invoiceID

            // Log the event to google analytics
            trackEvent(event)

            // Remove from sessionStorage now that we have logged it to google analytics
            window.sessionStorage.removeItem(sessionStorageKeyName)
        }
    }, isLabelsLoaded && !!invoiceID)
}
